import onboardingComponent from './onboarding/onboarding.module';
import onboardingHotelComponent from './onboarding-hotel/onboarding-hotel.module';
import passComponent from './pass/pass.module';

export default angular
    .module('app.core.modals', [
        onboardingComponent,
        onboardingHotelComponent,
        passComponent,
    ])
    .name;
